import { ITransfer } from "types/MoneyTransfers";

export const mapFormToRequestBody = ({
  orderId,
  moneyTransfers,
  note,
}: {
  orderId: string;
  moneyTransfers: ITransfer[];
  note?: string;
}) => {
  return {
    orderId,
    note,
    moneyTransfers: moneyTransfers
      .filter(
        (transfer) =>
          transfer.selectedPartyToTransferFrom &&
          transfer.selectedPartyToTransferTo &&
          transfer.selectedAmountToTransfer > 0
      )
      .map((transfer) => ({
        fromProviderId: transfer?.selectedPartyToTransferFrom?.id,
        toProviderId: transfer?.selectedPartyToTransferTo?.id,
        amountInCents: transfer.selectedAmountToTransfer,
        withholdClearFee: transfer.withholdClearFee,
      })),
  };
};
